import './App.css';
import 'antd/dist/reset.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SiderDemo from './components/Layout/Layout';
import 'bootstrap/dist/css/bootstrap.min.css';
import { connect, Provider } from "react-redux";
import store from './store/store';
import '@fontsource/lato';
import LeadGenerationAnalytics from './pages/Dashboard';
import TransactionPage from './pages/Transactions';
import MyLeads from './pages/MyLeads';
import MyLeadsBusiness from './pages/MyLeadsBusiness';
import RegistrationPage from './pages/Registration';
import AdminDashboard from './pages/AdminDashboard';
import Businesses from './pages/Businesses';
import RedirectMail from './pages/RedirectMail';
import Password from './pages/Password';
import Test from './pages/Test';
import Login from './pages/login';
import { useEffect } from 'react';
import { setUser } from './store/action/common/authAction';
import Tickets from './pages/Tickets';
import Setting from './pages/Setting';
import Helpdesk from './pages/Helpdesk';
import MySubscriptiontable from './pages/MySubscriptiontable';
import SubscriptionMaster from './pages/SubscriptionMaster';
import Customizedplan from './pages/Customizedplan';
import SubscriptionBill from './pages/SubscriptionBill';
import UtmMapping from './pages/UtmMapping';
import UtmMappingForm from './pages/UtmMappingForm';
import UpgradePlan from './pages/UpgradePlan';
import MyProfile from './pages/MyProfile';
import BandLMapping from './pages/BandLMapping';
import LeadBulkUpload from './pages/LeadBulkUpload';
import ForgotPassword from './components/Modals/ForgotPassword';

 

function App(props) {
  useEffect(() => {
    if(!props.user){
      const user = {
        email: JSON.parse(localStorage.getItem('email')),
        name: localStorage.getItem('name'),
        role: localStorage.getItem('role'),
      };
      if (!user.role) {
        localStorage.clear();
        props.setUser_(null);
        props.clearLoginResponse_();
      }
      props.setUser_(user)
    }
  })
  return (
      <Router>
        <Routes>
          <Route element={<SiderDemo />}>
            <Route path="/" element={<LeadGenerationAnalytics />} />
            <Route path="/transaction-history" element={<TransactionPage />} />
            <Route path="/my-leads" element={<MyLeads />} />
            <Route path="/my-bussiness-leads" element={<MyLeadsBusiness />} />
            <Route path="/setting" element={<Setting />} />
            <Route path="/helpdesk" element={<Helpdesk />} />
            <Route path="/my-profile" element={<MyProfile />} />
            <Route path="/upgrade-plan" element={<UpgradePlan />} />

            <Route path="/admin">
              <Route index element={<AdminDashboard />} />
              <Route path="businesses" element={<Businesses />} />
              <Route path="leadbulkupload" element={<LeadBulkUpload />} />
              {/* <Route path="tickets" element={<Tickets />} /> */}
              <Route path="subscription-master" element={<MySubscriptiontable />} />
              <Route path="utm-mapping" element={<UtmMapping />} />
              <Route path="utm-mapping-form" element={<UtmMappingForm />} />
              <Route path="business-and-lead-mapping" element={<BandLMapping />} />
              <Route path="subscription-master-form" element={<SubscriptionMaster />} />
              <Route path="business-mapping" element={<Customizedplan />} />
            </Route>

          </Route>
          <Route path="/subscription-bill/:id" element={<SubscriptionBill />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword/>} />
          {/* <Route path="/sign-up" element={<RegistrationPage />} /> */}
          {/* <Route path="/redirect-mail" element={<RedirectMail />} /> */}
          {/* <Route path="/password" element={<Password />} /> */}
          <Route path="/test" element={<Test />} />

        </Routes>
        <Routes>
        </Routes>
      </Router>
  );
}


const mapStateToProps = state => ({
  user: state.user.resposne
})

const mapDispatchToProps = dispatch => ({
  setUser_: (data)=>{
      dispatch(setUser(data));
  },
  clearLoginResponse_: ()=>{
      dispatch({type: 'FETCH_LOGIN_CLEAR'});
  }
}) 

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);